export default __webpack_public_path__ + "static/media/midterm2.e3afb575.jpg";